import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { mttAjax } from 'utils/_mtt_ajax'
import anime from 'animejs'
import GA4Tracking from 'app/GA4/utils/ga4-tracking'

function BasketButton(props){
  const [str] = useEnvValue('strings.putInBasket')
  const [product] = useEnvValue('product')
  const [selectedQuantity] = useEnvValue('selectedQuantity')
  const [selectedVariation] = useEnvValue('selectedVariation',null)
  const [addConsulting] = useEnvValue('planting.addConsulting',false)
  const [zipCode] = useEnvValue('planting.zipCode','')
  const [hedgePlant] = useEnvValue('planting.checked',false)
  const [loading, setLoading] = React.useState(false)
  const [minimumQuantity] = useEnvValue('minimumQuantity',1)

  const disabledClass = 'disabled';

  const canBuy = function(){
    if(selectedQuantity === null || selectedQuantity < minimumQuantity) return false;
    if(typeof selectedVariation !== 'object' || selectedVariation === null) return false;
    if(selectedVariation.stock === false || (typeof selectedVariation.stock === 'number' && selectedQuantity > selectedVariation.stock)) return false;
    return true
  }

  const classes = function(){
    let classes = [
      'button',
      'single_add_to_cart_button',
      'alt'
    ];
    if(!canBuy()) classes.push(disabledClass)
    if(loading) classes.push('loading')
    return classes
  }

  const getData = function(){
    let data = {
      action: 'add_variable_product_to_cart',
      quantity: selectedQuantity,
      product_id: product.id,
      variant_id: typeof selectedVariation === 'object' && selectedVariation !== null ? selectedVariation.id : null,
      consulting_visit: addConsulting,
      hedge_plant_postal:zipCode,
      hedge_plant: hedgePlant.toString()
    }
    return data
  }

  const putInCartCallback = function(res){
    setLoading(false)
    if(typeof res.data.mini_cart_html === 'string'){
      jQuery('.menu-mini-cart').html(res.data.mini_cart_html)
      jQuery('.menu-mini-cart').removeClass('closed')
      jQuery('#cart-overlay').addClass('show')

      handleModalOpen()
    }
    if(res.data.cart_count) {
      const CART_ITEM = document.querySelector('.mtt-header__main-nav-icon-link.mtt-open-cart .count')
      if (CART_ITEM) {
        CART_ITEM.innerHTML = res.data.cart_count
        CART_ITEM.classList.remove('hidden')
      }

      jQuery('.menu-mini-cart').removeClass('empty')
    }

    // GA4
    if (res.data.hasOwnProperty('ga_add_to_cart_item')) {
      GA4Tracking.pushEvent('add_to_cart', [res.data.ga_add_to_cart_item])
    }
    // document.querySelector('.menu-mini-cart').classList.remove('closed')
  }
  const putInCart = function () {
    setLoading(true)
    let data = getData()
    mttAjax('putInCart', data, putInCartCallback)
  }

  const handleOnClick = function(){
    if(!canBuy()){
      return
    }
    putInCart()
  }

  const handleModalOpen = function () {
    const modal = document.getElementById('did-you-miss-popup')
    if(!modal) return

    anime({
      targets: modal.children[0],
      opacity: [0, 1],
      translateY: [-30, 0],
      duration: 300,
      easing: 'easeOutCubic',
      delay: 200
    })

    document.body.classList.add('modal-open')
    modal.classList.add('active')
  }

  return (
      <button type="button" disabled={!canBuy()} onClick={handleOnClick} className={classes().join(' ')}>{str}</button>
  )
}

export default observer(BasketButton)